import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable ,of} from "rxjs";
import { map,} from "rxjs/operators";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
// import { PresenceService } from "src/app/services/presence.service";

import { environment } from '../../../environments/environment';
import { PermissionService } from './permission.service';
import { User } from '../models/user';
import { v4 as uuidv4 } from 'uuid';
import { jwtDecode } from 'jwt-decode';
import { IResponse } from '../models/iresponse';
import { Login } from '../models/login';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

 //API URLS
 API_Auth = `${environment.apiUrl}/Auth`;
 API_USERS_URL = `${environment.apiUrl}/Auth/login`;
 API_Verify_URL = `${environment.apiUrl}/Auth/VerifyOTP`;
 API_Register = `${environment.apiUrl}/Auth/Register`;
 API_ChangeData = `${environment.apiUrl}/Auth/ChangeData`;
 
 user: User|any;
 
 //Variables
 authUser:any= null;

 blockTimer$ = new BehaviorSubject<number>(0)
 timerInterval: any

 constructor(
   private router: Router,
   private permissionService: PermissionService,
   private http: HttpClient,
   // private presence: PresenceService
   ) {
   const subscr = this.getUserByToken().subscribe();
 }

 getDecodedToken(token: string): Observable<any> {
   return of(jwtDecode(token));
 }

 //Used after Login /Register
 setAuthedUser(tokenData:any,userData:any){
   this.authUser =  {...tokenData, ...userData};;
   // debugger;
 }

 // public methods
 loginHala(PhoneNumber: string, password: string): Observable<IResponse<Login>> {
   let param = {
     PhoneNumber: PhoneNumber,
     password: password,
     deviceId: localStorage.getItem(environment.deviceId)
   };
   return this.http.post<IResponse<Login>>(this.API_USERS_URL, param);
 }

 changeData(body:any): Observable<any> {
  return this.http.post<any>(this.API_ChangeData,body)
 }

 changePassword(body:any): Observable<any> {
  return this.http.post<any>(`${this.API_Auth}/ChangePassword`,body)
 }

 register(body:any): Observable<IResponse<Login>> {
   return this.http.post<IResponse<Login>>(this.API_Register,body)
  }

 VerifyThisOTP(PhoneNumber: string, code: string): Observable<any> {
   let param = {
     PhoneNumber: PhoneNumber,
     code: code
   };
   return this.http.get<any>(this.API_Verify_URL + `?PhoneNumber=${PhoneNumber}&code=${code}`)
 }


 logout() {
   localStorage.removeItem(environment.tokenName);
   localStorage.removeItem("UserId");
   localStorage.removeItem(environment.userDataName);
   localStorage.removeItem("userFullName");
   this.router.navigate(["/auth/login"], {
     queryParams: {},
   });
   //Stop signalR hub connection on logout 
   // this.presence.stopHubConnection();
 }

 public tokenExpired(token: string) {
   // const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
   // return (Math.floor((new Date).getTime() / 1000)) >= expiry;
   return false
 }

 // Function to check if unique ID exists, if not, generate and store it
 public getUniqueId() {
   let uniqueId = localStorage.getItem(environment.deviceId);
   if (!uniqueId) {
     uniqueId = uuidv4();  // Generate a new UUID
     localStorage.setItem(environment.deviceId, uniqueId);
   }
 }

 // Function to clear unique ID (optional, for logout or cleanup)
 public clearUniqueId(): void {
   localStorage.removeItem(environment.deviceId);
 }

 // Function to check if otp attempts exist in local storage
 public getOtpAttempts() {
   let attemptsCount = localStorage.getItem('otpAttempts');
   if (!attemptsCount) {
     localStorage.setItem('otpAttempts', '3');
   }
 }

 resetOtp(){
   clearInterval(this.timerInterval);
   localStorage.removeItem('otpAttempts');
   localStorage.removeItem('attemptsCounter');
 }

 // Called on page reload to continue timer if exist
 checkCounter() {
   clearInterval(this.timerInterval);
   let counter = localStorage.getItem('attemptsCounter')
   this.blockTimer$.next(counter ? JSON.parse(counter) : 0)
   if (this.blockTimer$.getValue() > 0) {
     this.countBlockTime()
   }
 }

 changeAttemptsCounter(blockTimer: number = 0) {
   localStorage.setItem('attemptsCounter', JSON.stringify(blockTimer))
   if (blockTimer > 0) {
     this.blockTimer$.next(blockTimer)
     this.countBlockTime()
   }
 }

 countBlockTime() {
   this.timerInterval = setInterval(() => {
     if (this.blockTimer$.getValue() > 0) {
       this.blockTimer$.next(this.blockTimer$.getValue() - 1)
       localStorage.setItem('attemptsCounter', JSON.stringify(this.blockTimer$.getValue()))
     } else {
       clearInterval(this.timerInterval);
       localStorage.setItem('attemptsCounter','0')
     }
   }, 1000)
 }

 getUserByToken(): Observable<any> {

   //Set user permission in the permission service (here case of refresh or access page without login as token not expired)
   this.permissionService.setPermissionsFromToken()
   //Create signalR hub connection on pagerefresh for websocket messages
   // let token = localStorage.getItem(environment.tokenName)
   // if(token){
   //   debugger
   //   this.presence.createHubConnection(token);
   // }
   this.getOtpAttempts()
   this.checkCounter()
   this.getUniqueId()
   let userToken = localStorage.getItem(environment.tokenName);
   let userData = JSON.parse(localStorage.getItem(environment.userDataName)!);
   if (!userToken || !userData) {
     return of(undefined);
   }else{
     //Check if token expired first
     if(this.tokenExpired(userToken)){
       this.logout();
       return of(undefined);
      
     }else{
       return this.getDecodedToken(userToken).pipe(
         map((tokenData: any) => {
           if (tokenData) {
             this.authUser = {...tokenData,...userData};
            //  console.log("Authed user",this.authUser)
           } else {
             // this.logout();
           }
           return this.authUser;
         }),
       )
     }
   }
 }

}
